import produce from "immer";
import { LoadState } from "../../constants/enums";
import { defaultPaymentType, defaultPaymentTypeState } from "./default";
import { CLEAR_PAYMENT_TYPE, FETCH_PAYMENT_TYPE_FAILED, FETCH_PAYMENT_TYPE_PROGRESS, FETCH_PAYMENT_TYPE_SUCCESS } from "./paymentAction";
import { PaymentTypeActions } from ".";
import { IStoreState } from "../initialStoreState";




export const paymentTypeReducer = (
state: IStoreState["paymentType"] = defaultPaymentTypeState,
action: PaymentTypeActions
) => {
    switch (action.type) {
        case FETCH_PAYMENT_TYPE_PROGRESS: {
             const newState = produce(state, (draftState) => {
               draftState.paymenttype.loading = LoadState.InProgress;
               draftState.list.data = [];
               draftState.paymenttype.data = defaultPaymentType;
             });
             return newState;
           }
           case FETCH_PAYMENT_TYPE_SUCCESS: {
             const { data } = action.payload;
             console.log("data===>",data);
             
             const newState = produce(state, (draftState) => {
               draftState.paymenttype.loading = LoadState.Loaded;
               draftState.list.data = data;
              
             });
             return newState;
           }
           case FETCH_PAYMENT_TYPE_FAILED: {
             const newState = produce(state, (draftState) => {
               draftState.paymenttype.loading = LoadState.Failed;
               draftState.list.data = [];
             });
             return newState;
           }
           case CLEAR_PAYMENT_TYPE: {
            return defaultPaymentTypeState;
           }
          
           default: {
            return state;
          }
      }
}